import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "handle"]
  static values = { url: String, reloadAfterSort: { type: Boolean, default: false } }

  connect() {
    this.draggedItem = null

    this.itemTargets.forEach(item => {
      item.setAttribute("draggable", "true")

      item.addEventListener("dragstart", this.#onDragStart.bind(this))
      item.addEventListener("dragover", this.#onDragOver.bind(this))
      item.addEventListener("dragend", this.#onDragEnd.bind(this))
      item.addEventListener("drop", this.#onDrop.bind(this))
    })
  }

  #onDragStart(event) {
    this.draggedItem = event.currentTarget
    event.currentTarget.classList.add("opacity-50")
    event.dataTransfer.effectAllowed = "move"
  }

  #onDragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"

    const target = event.currentTarget
    if (target === this.draggedItem) return

    const rect = target.getBoundingClientRect()
    const midY = rect.top + rect.height / 2

    if (event.clientY < midY) {
      target.parentNode.insertBefore(this.draggedItem, target)
    } else {
      target.parentNode.insertBefore(this.draggedItem, target.nextSibling)
    }
  }

  #onDrop(event) {
    event.preventDefault()
  }

  #onDragEnd() {
    if (this.draggedItem) {
      this.draggedItem.classList.remove("opacity-50")
    }

    const items = this.itemTargets
    const promises = items.map((item, index) => {
      const id = item.dataset.id
      const url = this.urlValue.replace(":id", id)

      return fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
        },
        body: JSON.stringify({ position: index })
      })
    })

    if (this.reloadAfterSortValue) {
      Promise.all(promises).then(() => window.location.reload())
    }

    this.draggedItem = null
  }
}
